import React, { Component} from 'react'
import { observer } from 'mobx-react'
import Tooltip from 'react-tooltip-lite'

import Store from '../../store/ProductionTableStore'

import TableTask from './TableTask'
import Popup from '../popup'
import DownloadIcon from '../icons/download'
import PauseIcon from '../icons/pause'

@observer
class TableBody extends Component {
    handleOpenNewWindow = (id, type) => {
        if (id) {
            let path = ''

            if (type === 'costEstimateId') {
                path = '/cost-estimates'
            } else if (type === 'companyId') {
                path = '/customers'
            }

            path = `${ path }/${ id }`
            
            window.open(path)
        }
    }

    render() {        
        const order = this.props.order
        const date = this.props.date
        const orderPosition = this.props.orderPosition
        const userId = Store.user.id

        let fileBtn = null
        let deliveryBtn = null
        let tasks = []
        let taskPopUp = null
        let tableIcon = null
        let tableIconTitle = 'Klicka för att öppna'
        let departmentColors = []

        /**
         * @todo
         * Quick fix for checking data. Should be moved to mobx-state.
         */
        let costEstimateId = null
        let costEstimateNumber = null
        let costEstimateName = ''
        let ourReferenceName = ''
        let ItemClasses = ''
        let customerId = null

        if (order.cost_estimate) {
            costEstimateName = order.cost_estimate.name
            costEstimateId = order.cost_estimate.id
            costEstimateNumber = order.cost_estimate.cost_estimate_number
            customerId = order.cost_estimate.customer_id

            if (order.cost_estimate.our_reference) {
                ourReferenceName = order.cost_estimate.our_reference.firstname
            }
        }

        if (order.tasks.length > 0) {
            let tempColors = []

            order.tasks.forEach((task, key) => {
                tasks.push(<TableTask
                    key={ `table-task-${ key }` }
                    data={ task }
                    date={ date }
                    orderPosition={ orderPosition }
                    position={ key }
                />)

                if (task.article && task.department_hex_color) {
                    if (!tempColors.includes(task.department_hex_color)) {
                        tempColors.push(task.department_hex_color)
    
                        departmentColors.push(
                            <span
                                className="table__row__cell__color"                            
                                key={`key-color-${ key }`}
                                style={{ backgroundColor: task.department_hex_color }}
                                title={ task.department_name }
                            >                            
                            </span>
                        )
                    }
                }
            })
            
            taskPopUp = <Popup
                type="warning"
                show={ Store.popupOrder.show }
                order={ order }
            />            
        }

        ItemClasses += ` table__row--${ order.status }`
        var ItemStatus = '';

        if (order.openTaskBar) {
            ItemClasses += 'table__row--open'
        }

        if (order.status === 'done') {
            ItemClasses += ' table__row--done'
            ItemStatus = 'Klar'
        } else if (order.status === 'started') {
            ItemClasses += ' table__row--started'
            ItemStatus = 'Påbörjad'
        } else if (order.status === 'not-started') {
            ItemStatus = 'Ej påbörjad'
        } else if (order.status === 'delayed-delivered') {
            ItemClasses += ' table__row--delayed-delivered'
            ItemStatus = 'Försenad ej levererad'
        } else if (order.status === 'delayed') {
            ItemClasses += ' table__row--delayed'
            ItemStatus = 'Försenad'
        } else if (order.status === 'paused') {
            ItemClasses += ' table__row--paused'
            ItemStatus = 'Pausad'
        }

        if (order.star == 1) {
            ItemClasses += ' table__row--neverHide';
        }

        if (order.orderDone) {
            deliveryBtn = <button className="pt-btn pt-btn--link" onClick={ () => window.location = `/cost-estimates/${ costEstimateId }/delivery` }>
                Leverans
                <span></span>
            </button>
        }

        if (order.pdf_file) {
            fileBtn = <button className="pt-btn pt-btn--link" onClick={ () => window.location = order.pdf_file }>
                Arbetsorder
                <DownloadIcon />
            </button>
        }

        if (order.order_paused) {
            tableIcon = <Tooltip
                direction="right"
                content={ <span dangerouslySetInnerHTML={{ __html: `<i>Kommentar för paus:</i><br />${ order.comment }` }}></span> }                
            >
                <PauseIcon />
            </Tooltip>

            if (order.openTaskBar) {
                tableIconTitle = 'Pausad - Klicka för att stänga'
            } else {
                tableIconTitle = 'Pausad - Klicka för att öppna'
            }
        } else {
            tableIcon = <span className={`table__row__cell__icon--arrow ${ order.openTaskBar ? 'table__row__cell__icon--arrow-open' : '' }` }></span>

            if (order.openTaskBar) {
                tableIconTitle = ItemStatus +' - Klicka för att stänga'
            } else {
                tableIconTitle = ItemStatus +' - Klicka för att öppna'
            }
        }

        return <div className={ `table__row ${ ItemClasses }` }>
            <div
                className="table__row__cell table__row__cell__icon"
                onClick={ Store.HANDLE_TOGGLE_TASKS.bind(this, order) }
                title={ tableIconTitle }
            >
                { tableIcon }
            </div>
            <div className="table__row__cell">
                <span onClick={ this.handleOpenNewWindow.bind(this, costEstimateId, 'costEstimateId') }>
                    { costEstimateNumber }
                </span>                
            </div>
            <div className="table__row__cell table__row__cell--tiny">
                <span onClick={ Store.STAR.bind(this, order) } className={`fa-star ${ order.star == 1 ? 'fa ' : 'far' }`}>
                   
                </span>                
            </div>
            <div className="table__row__cell table__row__cell--lg" title={ costEstimateName }>
                <span onClick={ this.handleOpenNewWindow.bind(this, costEstimateId, 'costEstimateId') }>
                    { costEstimateName }
                </span>                
            </div>
            <div className="table__row__cell table__row__cell--icon table__row__cell--md" title={ order.customer ? order.customer.name : 'Okänd kund' }>
                <span className="table__row__cell__icon table__row__cell__icon--person" onClick={ Store.HANDLE_CUSTOMER_POP_UP.bind(this, date, orderPosition) } title="Kontaktperson">
                    <span className="btn btn-icon btn-icon--person btn-icon--noText ml-1 mr-1"></span>
                </span>
                <span onClick={ this.handleOpenNewWindow.bind(this, customerId, 'companyId') }>
                    { order.customer ? order.customer.name : 'Okänd kund' }
                </span>                    
            </div>
            <div className="table__row__cell"><span onClick={ Store.HANDLE_DATE_POP_UP.bind(this, order) }>{ order.production_date}</span></div>
            <div className="table__row__cell"><span onClick={ Store.HANDLE_DATE_POP_UP.bind(this, order) }>{ order.delivery_date}</span></div>
            <div className="table__row__cell table__row__cell--shipper" title={ order.shipper }><span>{ order.shipper }</span></div>
            <div className="table__row__cell">{ `${ ourReferenceName }` }</div>
            <div className="table__row__cell table__row__cell--sm table__row__cell--right">{ order.quantity }</div>
            <div className="table__row__cell table__row__cell--right">{ order.value_amount_display }</div>
            <div className="table__row__cell table__row__cell--right">{ order.orderTotalTime_display }</div>
            <div className="table__row__cell table__row__cell--right">{ order.remainingTime_display }</div>
            <div className="table__row__cell table__row__cell--center table__row__cell--right">{ departmentColors.length > 0 ? departmentColors : '-' }</div>
            <div className="table__row__cell table__row__cell--right">{ `${ order.orderPercentileTotal }%` }</div>

            <div className={ `table__row__tasks ${ order.openTaskBar ? 'table__row__tasks--open' : '' }` }>
                { tasks }
                { taskPopUp }

                <div className="table__row__tasks__recap">
                    <div className="table__row__tasks__recap__holder">
                        <p className="table__row__tasks__recap__holder__txt">{ order.production_info }</p>
                    </div>

                    <div className="table__row__tasks__recap__actions"> 
                        { fileBtn }
                        { deliveryBtn }                       

                        <label className="control control--checkbox control--checkbox-done">Klar
                            <input
                                className="control__input"
                                type="checkbox"
                                checked={ order.orderDone }
                                onChange={ Store.HANDLE_SET_TASKS_ASYNC.bind(this, date, -1, orderPosition, userId) }
                            />
                            <div className="control__indicator control__indicator--dark-green"></div>
                        </label>
                    </div>
                </div>                                    
            </div>
        </div>
    }
}

export default TableBody
